import React from 'react';
const parse = require('html-react-parser');
var striptags = require('striptags');

class MainQuestion extends React.Component{
    constructor(props) {
        super(props);


    }

    render(){
        let substr;
        if(this.props.frageTitle.length>2) {
            if(this.props.frageTitle[2]!="") {
                if (this.props.frageTitle[2].includes('<strong>')) {
                    substr = this.props.frageTitle[2];
                } else {
                    substr = "<strong>" + this.props.frageTitle[2] + "</strong>"
                }
                return (
                    <div className="questionName centered">
                        <div className="questionHeading">
                            <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}></p>
                            <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></p>
                           {/* <p>{this.props.frageTitle[0]}</p>
                            <p>{this.props.frageTitle[1]}</p>*/}
                        </div>
                        <div className="questionSecondHeading">
                            <p dangerouslySetInnerHTML={{__html: substr}}></p>
                        </div>

                    </div>
                );
            }else{
                return (
                    <div className="questionName centered">
                        <div className="questionHeading">
                            <p>dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}</p>
                        </div>
                        <div className="questionSecondHeading">
                            <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></p>
                        </div>

                    </div>
                );
            }
        }
        else{
            return (
            <div className="questionName centered">
                <div className="questionHeading">
                    <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}></p>
                </div>
                <div className="questionSecondHeading">
                    <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></p>
                </div>

            </div>
            );
        }
    }
}
export default MainQuestion
